import {createContext} from "react";

export default createContext({
	languages: [],
	loading: false,
	getLanguages: () => {},
	createLanguage: () => {},
	removeLanguage: () => {}
});